// @ts-nocheck
import React, { Fragment } from 'react'
import ContentTypeFactory from './factory'
import parseStorageHtml from './parseStorageHtml'
import PageBuilderStyleTags from './PageBuilderStyleTags'

/**
 * Page Builder component for rendering Page Builder master storage format in React
 */
const PageBuilder = ({
    masterFormat,
    data: preParsedData,
    isLazyLoad,
    ProductTile,
    productQuery,
    imageNavCallback
}) => {
    const data =
        preParsedData ?? (masterFormat ? parseStorageHtml(masterFormat) : null)

    if (!data?.children) {
        return null
    }

    return (
        <>
            <PageBuilderStyleTags
                cssBlocks={data.cssBlocks || []}
                // eslint-disable-next-line i18next/no-literal-string
                idPrefix="pb-root"
            />
            {data.children.map((child, i) => (
                <ContentTypeFactory
                    key={i}
                    data={child}
                    isLazyLoad={isLazyLoad}
                    ProductTile={ProductTile}
                    productQuery={productQuery}
                    imageNavCallback={imageNavCallback}
                />
            ))}
        </>
    )
}

export default PageBuilder
